import { PresentScatterStateActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { ScatterHighlightEffect } from "@slot/presentation";
import type { AudioService } from "../../audio/ports/AudioService";
import type { HapticsService } from "../../haptics/HapticsService";
import type { WinSequencePresenter } from "./WinSequencePresenter";

/**
 * `present_scatter_state` → the scatter collect (decision 46): the cue and a soft haptic, the scatter cells lit over a
 * win's dim, then a pulse over each of them.
 */
export function createScatterPlugin(deps: {
  audioService: AudioService;
  hapticsService: HapticsService;
  presenter: WinSequencePresenter;
  scatterHighlightEffect: ScatterHighlightEffect;
}): ReplayPlugin {
  return {
    name: "scatter",
    actionHandlers: [
      new PresentScatterStateActionHandler(async (input) => {
        deps.audioService.presentation.emit({ id: "grid.scatter_collect" });
        deps.hapticsService.play("soft");
        deps.presenter.undimCellsAtIndices(input.positionIndices);
        await deps.scatterHighlightEffect.highlightScatterPositions({
          positionIndices: input.positionIndices,
          pulseCycles: 3,
          preDelayMilliseconds: 120,
          postDelayMilliseconds: 200,
        });
      }),
    ],
  };
}
